<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I’d like to thank my wife, Kathleen Welch, for spending hours minding our puppies solo while I worked on this manuscript. Thanks are also due to Amanda Ritter, who suggested that I revise the story to focus on Lou’s perspective, and Austin Macauley Publishers for their work on the final product.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7b1c98e4